import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../../components/Header/Header";
import Features from "../../../components/Feature-section/Features";
import Newsletter from "../../../components/Newsletter/Newsletter";
import Footer from "../../../components/Footer/Footer";
import { getPublishedCategoryCourseDetailBySlugORID } from "../../../controllers/coursesController";
import CourseDetailCard from "../../../components/Courses-section/Course-detail-section/CourseDetailCard";
import HeadSection from "../../../components/meta";
import BannerAd from "../../../components/Ads/bannerAd";

const CourseDetails = () => {
  const { cat, course } = useParams();
  const navigate = useNavigate();

  // Ensure values are properly formatted
  const category = cat || "";
  const courseSlug = decodeURIComponent(course || "");

  const [courseDetails, setCourseDetails] = useState(null);

  useEffect(() => {
    if (!category || !courseSlug) {
      navigate("/", { replace: true });
      return;
    }

    const fetchCourseDetails = async () => {
      console.log(category);
      
      const fetchedCourse = await getPublishedCategoryCourseDetailBySlugORID(
        category,
        courseSlug
      );
console.log({ fetchedCourse });
      if (fetchedCourse) {
        setCourseDetails(fetchedCourse);
      }
    };

    fetchCourseDetails();
  }, [category, courseSlug, navigate]);
console.log({courseDetails});


  return (
    <>
      <HeadSection
        title={`${
          courseDetails?.title?.toUpperCase() || courseSlug
        } | ${category.toUpperCase()} | COURSES`}
        keywords=""
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        link={`/courses/${category}/${courseSlug}`}
        content={`Showing details of ${category} course with ${courseSlug} id from Seed to Tree Academy.`}
      />
      <Header selected="courseDetails" />
      <BannerAd />
      <section className="courseDetails__list">
        {courseDetails ? (
          <CourseDetailCard courseDetails={courseDetails} />
        ) : (
          <h3>No Course Details Found !!!</h3>
        )}
      </section>
      <Features />
      <Newsletter />
      <Footer />
    </>
  );
};

export default CourseDetails;
